import React, { useState, useCallback } from "react"
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { FilterData, IndexType } from "../../../components/Extra"
import CategoriesTable from "./CategoriesTable"
import { CategoriesGrid } from "./CategoriesGrid"
import { AddNewCategory } from "./Modals/AddNewCategory"
import { categoriesData, categoryStats } from "../../../common/data/categories"
import { Category } from "./types"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo } from "react"
import { DeleteCategory } from "./Modals/DeleteCategory"
import { AddNewOffer } from "../Offers/Modals/AddNewOffer/AddNewOffer"
import { AddNewCampaign } from "../Campaigns/Modals/AddNewCampaign"

export const Categories = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [checkedCategories, setCheckedCategories] = useState<Category[]>([])
  const [categories, setCategories] = useState<Category[]>([])
  const [filteredCategories, setFilteredCategories] = useState<Category[]>([])
  const [openAddNewCategoryModal, setOpenAddNewCategoryModal] =
    useState<boolean>(false)
  const [showDeleteCategoryModal, setShowDeleteCategoryModal] = useState(false)
  const [openAddNewOfferModal, setOpenAddNewOfferModal] =
    useState<boolean>(false)
  const [openAddNewCompaignModal, setOpenAddNewCompaignModal] =
    useState<boolean>(false)

  useEffect(() => {
    setCategories(categoriesData)
    setFilteredCategories(categoriesData)
  }, [])

  const isAllChecked = useMemo(
    () =>
      categories.length > 0 && checkedCategories.length === categories.length,
    [categories, checkedCategories]
  )

  const togglecheckedCategoryHandler = useCallback((category: Category) => {
    setCheckedCategories(prev =>
      prev.includes(category)
        ? prev.filter(c => c !== category)
        : [...prev, category]
    )
  }, [])

  const toogleActiveCategory = useCallback(
    (category: Category) => {
      setCategories(prev =>
        prev.map(c =>
          c.id === category.id
            ? {
                ...c,
                status: category.status === "Active" ? "In Active" : "Active",
              }
            : c
        )
      )
    },
    [categories]
  )

  const toggleAllCategories = useCallback(() => {
    setCheckedCategories(isAllChecked ? [] : categories)
  }, [isAllChecked, categories])

  const addNewCategoryHandler = useCallback(() => {
    setOpenAddNewCategoryModal(true)
  }, [])
  const editCategoryHandler = useCallback((id: string) => {
    console.log(id)
    navigate(`/categories/${id}`)
  }, [])
  const deleteCategoryHandler = useCallback((category: Category) => {
    setShowDeleteCategoryModal(true)
  }, [])
  const viewDetailsHandler = useCallback((id: string) => {
    navigate(`/categories/${id}`)
  }, [])
  const addOfferHandler = useCallback((category: Category) => {
    setOpenAddNewOfferModal(true)
  }, [])
  const addCompaign = useCallback((category: Category) => {
    setOpenAddNewCompaignModal(true)
  }, [])

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("categories_categories")}
        />
        <Button
          onClick={addNewCategoryHandler}
          className="bg-gradiant-blue text-capitalize btn btn-secondary border-0"
        >
          {t("categories_addNewCategory")}
        </Button>
      </div>
      <FilterData
        data={categories}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredCategories}
      />

      {/* Modals */}
      <AddNewCategory
        isOpen={openAddNewCategoryModal}
        toggle={() => setOpenAddNewCategoryModal(false)}
      />
      <DeleteCategory
        isOpen={showDeleteCategoryModal}
        toggle={() => setShowDeleteCategoryModal(!showDeleteCategoryModal)}
      />

      <AddNewOffer
        formSubmitedHandler={() => {}}
        isOpen={openAddNewOfferModal}
        toggle={() => setOpenAddNewOfferModal(false)}
      />

      <AddNewCampaign
        isOpen={openAddNewCompaignModal}
        toggle={() => setOpenAddNewCompaignModal(false)}
      />

      {activeTab == "list-ul" ? (
        <CategoriesTable
          categories={filteredCategories}
          isAllChecked={isAllChecked}
          checkedCategories={checkedCategories}
          toggleAllCategories={toggleAllCategories}
          togglecheckedCategoryHandler={togglecheckedCategoryHandler}
          toogleActiveCategory={toogleActiveCategory}
          editCategoryHandler={editCategoryHandler}
          deleteCategoryHandler={deleteCategoryHandler}
          viewDetailsHandler={viewDetailsHandler}
          addOfferHandler={addOfferHandler}
          addCompaign={addCompaign}
        />
      ) : (
        <CategoriesGrid
          categorys={filteredCategories}
          toggleActiveCategory={toogleActiveCategory}
          editCategoryHandler={editCategoryHandler}
          deleteCategoryHandler={deleteCategoryHandler}
          viewDetailsHandler={viewDetailsHandler}
          addOfferHandler={addOfferHandler}
          addCompaign={addCompaign}
        />
      )}
    </div>
  )
}
